import React, { Component } from 'react';
import logo from './assets/moon-logo.png';
import './Donations.css';

class Footer extends Component {
  render() {
    return (
      <div className="donations">
        <img src={logo} className="donations__logo" alt="donations__logo" />
        <div className="donations__title">Moon Tax is fueled by donations.</div>

        <div>
          If this service was helpful,<br />consider leaving us a tip.
        </div>

        <div className="donations__heart">{'<3'}</div>

        <div className="donations__address">
          <span className="bold">BTC:</span> 1LUkTsoEGRD6aZHU2fMHk8MsVyjyft3vpe
        </div>
        <div className="donations__address">
          <span className="bold">BCH:</span> 1DfymTfuoJXunYAeRm35FRkgrwCy4wmBEP
        </div>
        <div className="donations__address">
          <span className="bold">ETH:</span>{' '}
          0xbA4ba62505C83CfdE14331b3F1f00F4Ea02b76E6
        </div>
        <div className="donations__address">
          <span className="bold">LTC:</span> LeYZ84xKkB5eRzJ1aXsHED5wo3WVjWE85G
        </div>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Donations.js